import { defaultSettings } from '../config/styles';

const useSettings = () => defaultSettings;
export default useSettings;
